// TelcoTrack — map route / line rendering (SSOT for web + mobile parity comments).

/** VYKOP a další „thick“ workflow linie na mapě (Leaflet / Mapbox object layer). */
export const MAP_OBJECT_LINE_OPACITY = 0.95;
/** Informativní trasy (STAVAJICI) — mírně průhlednější než VYKOP. */
export const MAP_OBJECT_LINE_OPACITY_INFORMATIVE_ROUTE = 0.78;
/** @deprecated Use {@link MAP_OBJECT_LINE_OPACITY_INFORMATIVE_ROUTE}. */
export const MAP_OBJECT_LINE_OPACITY_STAVAJICI = MAP_OBJECT_LINE_OPACITY_INFORMATIVE_ROUTE;
/** Optional PD-imported R100 underlay (non-interactive dashed project route). */
export const MAP_OBJECT_LINE_OPACITY_PD_R100_UNDERLAY = 0.4;
export const MAP_OBJECT_LINE_WEIGHT_PD_R100_UNDERLAY = 2;
export const MAP_OBJECT_LINE_DASH_PD_R100_UNDERLAY = '6, 8';
export const MAP_OBJECT_LINE_COLOR_PD_R100_UNDERLAY = '#94a3b8';
export const MAP_OBJECT_LINE_WEIGHT_THICK = 6;
export const MAP_OBJECT_LINE_WEIGHT_THIN = 2;
export const MAP_OBJECT_LINE_WEIGHT_DEFAULT = 3;

/** Šířka line objektů na Mapbox (Android/iOS/KMP) — parita s thick weight na webu. */
export const MAP_OBJECT_LINE_WIDTH = 5;
export const MAP_OBJECT_LINE_HIGHLIGHT_WIDTH = 8;

/** Náhled polyline při výběru trasy (segment selection, před potvrzením). */
export const MAP_ROUTE_SELECTION_PREVIEW_COLOR = '#2563eb';
export const MAP_ROUTE_SELECTION_PREVIEW_WEIGHT = 4;

/** Potvrzená trasa (route panel, confirmedRoutePane / selected-segment layer). */
export const MAP_ROUTE_CONFIRMED_WEIGHT = 7;
export const MAP_ROUTE_CONFIRMED_OPACITY = 1;

/** Mini mapa trasy ve stavebním deníku / výkazu práce (nebarvená fází). */
export const MAP_ROUTE_DIARY_PREVIEW_COLOR = '#1d4ed8';
export const MAP_ROUTE_DIARY_PREVIEW_WEIGHT = 5;
export const MAP_ROUTE_DIARY_PREVIEW_OPACITY = 1;
